import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVenus, faHandsHelping, faUserShield } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom'; // For navigation



const WomenEmpowerment: React.FC = () => {
  const navigate = useNavigate(); // Hook for navigation

  const handleDonateClick = () => {
    navigate('/donate');
  };

  return (
    <div className="women-empowerment-page">
      {/* Section 1: Hero Section with Background Image and Overlay */}
      <div className="hero-section" style={{ backgroundImage: `url('https://media.licdn.com/dms/image/v2/D5612AQHAEU3lO_gh3A/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1697383565850?e=2147483647&v=beta&t=3hIc-Ul93enNXeuUoaMF__hB-8OOTOF4B5zzA96tXJQ')` }}>
        <div className="overlay">
          <Container className="text-center py-5">
            <h1 className="hero-title">Empowering Women for a Better Tomorrow</h1>
            <p className="hero-subtitle">Equipping women with skills, support, and opportunities to lead independent and impactful lives.</p>
            <Button variant="outline-light" className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Container>
        </div>
      </div>

      {/* Section 2: Our Vision */}
      <Container className="my-5">
        <Row className="align-items-center">
          <Col md={6} className="order-md-2">
            <img
              src="https://insights.careinternational.org.uk/media/k2/items/cache/3dcbd8056f504532259e733a4b9e2ae3_L.jpg"
              alt="Women Empowerment"
              className="img-fluid rounded shadow-lg"
            />
          </Col>
          <Col md={6} className="order-md-1">
            <h2 className="section-title"><FontAwesomeIcon icon={faVenus} className="me-2" /> Our Vision</h2>
            <p className="section-text">
              At Srisailam Foundation, we strive to empower women through skill development, economic independence, and a supportive environment. Our goal is to build a society where every woman lives with dignity, confidence, and equal opportunity.
            </p>
            <Button className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Section 3: Empowerment Programs */}
      <Container className="my-5 py-5" style={{ backgroundColor: '#F3F4F6' }}>
        <h2 className="text-center section-title mb-5"><FontAwesomeIcon icon={faHandsHelping} className="me-2" /> Empowerment Programs</h2>
        <Row className="g-4">
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Body className="text-center">
                <FontAwesomeIcon icon={faHandsHelping} size="3x" className="mb-3 icon" />
                <Card.Title className="card-title">Skill Development</Card.Title>
                <Card.Text className="card-text">
                  Providing training in crafts, technology, and entrepreneurship to help individuals build sustainable livelihoods and brighter futures.
                </Card.Text>
                <Button variant="outline-primary" size="sm" className="donate-btn" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Body className="text-center">
                <FontAwesomeIcon icon={faUserShield} size="3x" className="mb-3 icon" />
                <Card.Title className="card-title">Safety Initiatives</Card.Title>
                <Card.Text className="card-text">
                  Implementing programs that promote women’s safety and provide legal support in vulnerable situations.
                </Card.Text>
                <Button variant="outline-primary" size="sm" className="donate-btn" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Body className="text-center">
                <FontAwesomeIcon icon={faVenus} size="3x" className="mb-3 icon" />
                <Card.Title className="card-title">Health & Wellness</Card.Title>
                <Card.Text className="card-text">
                  Advancing women’s well-being through health education, preventive care, and wellness initiatives.
                </Card.Text>
                <Button variant="outline-primary" size="sm" className="donate-btn" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Section 4: Impact and Support */}
      <Container className="my-5 text-center">
        <h2 className="section-title mb-4"><FontAwesomeIcon icon={faUserShield} className="me-2" /> Make a Difference</h2>
        <p className="section-text mb-4">
          Your support can empower women to lead independent, confident, and fulfilling lives. Join us in creating lasting change.
        </p>
        <Button className="donate-btn" size="lg" onClick={handleDonateClick}>
          Donate Us
        </Button>
      </Container>
    </div>
  );
};

export default WomenEmpowerment;